import { Container, i18n, utils, http } from "@common";
import { useEffect, useState } from 'react';
import { accountService, transferService } from '@api';
import './index.less';
function Home() {
    const [userProfile, setUserProfile] = useState(null);
    const [userName, setUserName] = useState(null);
    const [quickLinks, setQuickLinks] = useState([]);
    const [queryParams, setQueryParams] = useState({});
    const [changePasswordUrl, setChangePasswordUrl] = useState('');
    const params = utils.geturlparam(window?.location.search);
    const pathName = window.location.pathname;

    useEffect(() => {
        $$.loading(true);
        accountService.getCurrentUser().then(() => {
            Promise.all([
                accountService.getUserInfo(),
                accountService.getUserProfile(),
                transferService.getQuickLinks(),
            ]).then(([userInfo, userPhoto, quickLinks]) => {
                $$.loading(false);
                const userId = userInfo?.detail?.sub?.split('@')[0] || '';
                userInfo?.detail?.name && setUserName(userInfo?.detail?.name);
                userPhoto?.detail?.ImageBase64 && setUserProfile(userPhoto?.detail?.ImageBase64);
                quickLinks?.detail && setQuickLinks(quickLinks?.detail);
                setQueryParams({ ...queryParams, sub: userInfo?.detail?.sub, mail: userInfo?.detail?.mail });
                const param = { sub: encodeURIComponent(userId) || '' };
                accountService.goToChangePassword(param).then(res => {
                    setChangePasswordUrl(res?.detail);
                }).catch(e => {
                    throw e;
                }).finally(() => {
                    $$.loading(false);
                });
            }).catch(e => {
                $$.loading(false);
                throw e;
            });
        }).catch(err => {
            const { search } = params;
            if (err?.errorCode === http.ErrorCode.CodeError) {
                accountService.regoLogin(`${utils.getOriginUrl()}${pathName}${search ?? ""}`).then((res) => {
                    utils.redirectTo(res?.detail);
                });
            }
            $$.loading(false);
        });
    }, []);

    const handleChangeEvent = (type) => {
        $$.loading(true);
        let redirect_uri = '';
        if (type === 'password') {
            $$.loading(false);
            if (changePasswordUrl) {
                utils.redirectTo(changePasswordUrl, '', '', true);
            }
        } else if (type === '2fa') {
            $$.loading(false);
            redirect_uri = `https://account.activedirectory.windowsazure.com/passwordreset/register.aspx?sspr=1`;
            utils.redirectTo(redirect_uri, '', '', true);
        }
    };

    const handleLinkClick = (url) => {
        url && utils.redirectTo(url, "", "", true);
    };

    const getFirstName = (name) => {
        if (!name || !name?.length) return '';
        let arr = name.split(" ");
        let fristCode = '';
        $.each(arr, function (i, v) {
            fristCode += v.substr(0, 1);
        });
        return fristCode.toUpperCase();

    };
    return (
        <Container>
            <div id="div-student-container">
                <div className="div-left-user-box">
                    <div className="user-profile">
                        <div className="user-photo-box">
                            {userProfile ? <img className="user-photo" src={`data:image/png;base64,${userProfile}`} /> : <span className="user-first-name">{getFirstName(userName)}</span>}
                        </div>
                        <div className="user-name">{userName}</div>
                    </div>
                    <div className="div-change-box-container">
                        <div className="div-change-password" onClick={() => handleChangeEvent('password')}>
                            <div className="change-password-box">
                                <icon className="fia-change-password"></icon>
                            </div>
                            <div className="icon-name">{i18n.get('CIS_Student_Home_ChangePassword_Entry')}</div>

                        </div>
                        <div className="div-change-2fa" onClick={() => handleChangeEvent('2fa')}>
                            <div className="change-2fa-box">
                                <icon className="fia-change-2fa"></icon>
                            </div>
                            <div className="icon-name">{i18n.get('CIS_Student_Home_Change2FA_Entry')}</div>
                        </div>
                    </div>
                </div>
                <div className="div-right-quick-links wrapper">
                    <div className="div-quick-linck-title">{i18n.get('CIS_Student_Home_QuickLinks_Entry')}</div>
                    <div className="div-links-container row-flex">
                        {quickLinks?.map((item, index) => {
                            return (
                                <div key={index} className="div-links col-lg-4 col-md-6 col-sm-12 col-xs-12" onClick={() => handleLinkClick(item?.MainPageUrl)}>
                                    <div className="links-name" data-tooltip="ifneed">{item?.AssignedName}</div>
                                    <span className="icon fia-arrow-right-subnav"></span>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </Container>
    );
}
export default Home;